attribute float instanceLastEvent;
attribute float instanceDissolveValue;
varying float vDepthLastEvent;
varying float vDepthDissolveValue;
varying vec2 vUv;
